import React from 'react'
import { capitalize } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { CustomerDetailsSection } from 'pages/Customers/ConfirmCustomer/CustomerDetails'
import { AddCustomerPayload } from 'types/customers'

interface CompanyCustomerConfirmationProps {
  customer: AddCustomerPayload
}

export const CompanyCustomerConfirmation = ({ customer }: CompanyCustomerConfirmationProps) => {
  const { t } = useTranslation()

  const customerDetails = [
    { label: t('customers.type'), value: capitalize(customer?.customerEntityType?.toLowerCase()) },
    { label: t('customers.businessName'), value: customer?.businessName },
    { label: t('customers.industry'), value: customer?.industryName },
    { label: t('customers.businessDescription'), value: customer?.businessDescription },
    { label: t('customers.businessRegistrationNumber'), value: customer?.registrationNumber },
    { label: t('customers.businessTaxResidency'), value: customer?.businessTaxResidencyName },
    { label: t('customers.businessMonthlyVolume'), value: customer?.businessMonthlyVolumeName },
  ]

  const addressDetails = [
    {
      label: t('customers.address.address'),
      value: [customer?.addressLine1, customer?.addressLine2, customer?.city, customer?.postalCode]
        ?.filter(Boolean)
        ?.join(', '),
    },
    { label: t('customers.country'), value: customer?.countryName },
  ]

  const representativeDetails = [
    { label: t('customers.representative.firstName'), value: customer?.firstName },
    { label: t('customers.representative.lastName'), value: customer?.lastName },
    { label: t('customers.representative.dateOfBirth'), value: customer?.dateOfBirth },
    { label: t('customers.representative.nationality'), value: customer?.nationalityName },
  ]

  return (
    <>
      <CustomerDetailsSection customerDetails={customerDetails} />
      <CustomerDetailsSection
        title={t('customers.registeredAddress')}
        customerDetails={addressDetails}
      />
      <CustomerDetailsSection
        title={t('customers.representative.title')}
        customerDetails={representativeDetails}
      />
    </>
  )
}
